module.exports = __webpack_public_path__ + "static/media/landing_01.ddc2770e.svg";